var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderNotchMinus = function SvgIconFolderNotchMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.875a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9.796 4.6 2.537 1.9h7.917A1.75 1.75 0 0 1 22 8.25v10.5a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18.75V6a1.75 1.75 0 0 1 1.75-1.75h5.001a1.76 1.76 0 0 1 1.043.348zM4 6.25v2.5h4.664l1.668-1.25-1.668-1.25zm4.747 3.5v1H4v7.75h16v-10h-7.667l-2.54 1.902a1.76 1.76 0 0 1-1.042.348z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFolderNotchMinus;